import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { getDescriptionForAge } from '../../../../resources/utilities'
import {polyglot} from '../../../../index'
import FormRenderer from '../../../common/FormRenderer/FormRenderer'
import { ReactModal } from '../../../common/ReactModal/ReactModal'
import EruptionInsertionForm from '../EruptionInsertionForm/EruptionInsertionForm'

export default class TeethEruption extends React.Component {
  constructor (props) {
    super(props)
    this.toggleModal = this.toggleModal.bind(this)
    this.saveData = this.saveData.bind(this)
    this.getSavedDataForKey = this.getSavedDataForKey.bind(this)
    this.state = {
      modalIsOpen: false,
      eruptionDates: null,
      teethsToErupt: null
    }
  }

  componentWillMount () {
    this.updateComponentWithData(this.props)
  }

  updateComponentWithData (data) {
    if (data.consultationData && data.consultationData !== null) {
      this.setState({
        eruptionDates: data.consultationData.eruptionDates || null
      })
    }
    if (data.availableTeeth) {
      let _data = data.availableTeeth
      if (data.consultationData && data.consultationData.eruptionDates) {
        data.consultationData.eruptionDates.map(function (value) {
          const index = _data.indexOf(value.teeth)
          if (index !== -1) {
            _data.splice(index, 1)
          }
          return true
        })
      }
      this.setState({
        teethsToErupt: _data
      })
    }
  }

  componentWillReceiveProps (props) {
    this.updateComponentWithData(props)
  }

  toggleModal () {
    if (this.state.teethsToErupt && this.state.teethsToErupt.length > 0) {
      this.setState({
        modalIsOpen: !this.state.modalIsOpen
      })
    } else if (!this.state.teethsToErupt) {
      this.setState({
        modalIsOpen: !this.state.modalIsOpen
      })
    } else {
      window.alert(polyglot.t('staticText.noTeethToInsert'))
    }
  }

  saveData (data, key) {
    this.setState({
      [key]: data
    })
    this.props.handleChange(data, key)
  }

  saveEruptionInsertion (data) {
    this.toggleModal()
    const value = {
      teeth: Number(data.toothId.substring(0, 2)),
      date: data.eruptionDate
    }
    let obj = this.state.eruptionDates
    if (obj) {
      obj.push(value)
    } else {
      obj = []
      obj.push(value)
    }
    this.setState({
      eruptionDates: obj
    }, this.props.handleChange(obj, 'eruptionDates'))
  }

  getSavedDataForKey (key) {
    if (this.props.consultationData && this.props.consultationData.hasOwnProperty(key)) {
      return this.props.consultationData[key]
    }
  }

  renderFeeding () {
    if (this.props.config) {
      const element = this.props.config.feeding
      return <FormRenderer
        extraFieldContent={element.extraFieldContent}
        saveData={this.saveData}
        savedData={this.getSavedDataForKey(element.key)}
        key={element.key}
        dataKey={element.key}
        title={element.title}
        fields={element.fields}
        extraFieldEnabled={element.isExtraFieldEnabled} />
    }
  }

  renderDetailsByAge () {
    if (this.props.config) {
      const element = this.props.config.detailsByAge
      return <FormRenderer
        extraFieldContent={element.extraFieldContent}
        saveData={this.saveData}
        savedData={this.getSavedDataForKey(element.key)}
        key={element.key}
        dataKey={element.key}
        title={element.title}
        fields={element.fields}
        extraFieldEnabled={element.isExtraFieldEnabled} />
    }
  }

  render () {
    return (
      <div>
        <div className='page-header'>
          <h2>{polyglot.t('staticText.teethEruption')}</h2>
        </div>
        <div className='panel panel-default'>
          <div className='panel-body center'>
            <EruptionByMonths patientBirthDate={this.props.patientBirthDate} data={this.state.eruptionDates} teethData={this.props.teethData} />
            <br />
            <div className='btn btn-default btn-block' onClick={this.toggleModal}>{polyglot.t('staticText.addEruption')}</div>
            <hr />
            {this.renderFeeding()}
            <hr />
            {this.renderDetailsByAge()}
            <hr />
          </div>
        </div>
        <ReactModal name={polyglot.t(this.props.config.eruptionInsertion.title)} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen}>
          <EruptionInsertionForm config={this.props.config.eruptionInsertion} saveChanges={this.saveEruptionInsertion.bind(this)}
            teeth={this.state.teethsToErupt} />
        </ReactModal>
      </div>
    )
  }
}

TeethEruption.propTypes = {
  config: PropTypes.object.isRequired,
  patientBirthDate: PropTypes.string.isRequired,
  teethData: PropTypes.array.isRequired,
  data: PropTypes.object,
  consultationData: PropTypes.object,
  handleChange: PropTypes.func.isRequired
}

class EruptionByMonths extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      elements: null
    }
  }

  componentWillMount () {
    this.updateComponentData(this.props)
  }

  updateComponentData (data) {
    if (data.data && data.patientBirthDate) {
      let weeks = {}
      data.data.map((element) => {
        const currElement = element
        const date = moment(element.date)
        const patientBirthDate = moment(data.patientBirthDate)
        const monthsDifference = date.diff(patientBirthDate, 'month')
        let description = getDescriptionForAge(monthsDifference)
        if (weeks[description]) {
          const element = {
            date: date,
            teeth: currElement.teeth
          }
          weeks[description].push(element)
        } else {
          const element = {
            date: date,
            teeth: currElement.teeth
          }
          weeks[description] = []
          weeks[description].push(element)
        }
        return null
      })
      this.setState({
        elements: weeks
      })
    }
  }

  componentWillReceiveProps (props) {
    this.updateComponentData(props)
  }

  render () {
    return <div>
      {this.state.elements
        ? <div className='timeline'>
          {
            Object.keys(this.state.elements).map(function (key) {
              return <div key={key}>
                <h3>{key}</h3>
                <ul>
                  {this.state.elements[key].map(function (value, index) {
                    return <li key={index}>
                      <h4><span>{`${value.teeth}`}</span>{` - ${polyglot.t(this.props.teethData[value.teeth].name)}`}</h4>
                      <time>{moment(value.date).format('LL')}</time>
                    </li>
                  }.bind(this))}
                </ul>
              </div>
            }.bind(this))
          }
        </div>
        : <h3>{polyglot.t('commonFields.noInformation')}</h3>
      }
    </div>
  }
}

// TODO EruptionByMonths propTypes insertion



// WEBPACK FOOTER //
// ./src/components/general/Age/TeethEruption/TeethEruption.js